import {Schema} from 'prosemirror-model'

import styles from './nodes.module.css'

// Note our schema doesn't support any phrasing content, only flow content (blocks). Phrasing content is
// represented by decorations since the user edits those Markdown delimiters directly in the editor
export const schema = new Schema({
  nodes: {
    // required: root document node
    doc: {
      content: 'flow*', // borrowing the 'flow' terminology from mdast
    },
    paragraph: {
      group: 'flow',
      content: 'text*',
      toDOM() {
        return ['p', 0]
      },
      inline: false,
      parseDOM: [
        {
          tag: 'p',
        },
      ],
    },
    heading: {
      attrs: {level: {default: 1, validate: (value: unknown) => typeof value === 'number' && value >= 1 && value <= 6}},
      group: 'flow',
      content: 'text*',
      toDOM(node) {
        return [`h${node.attrs.level}`, 0]
      },
      inline: false,
      parseDOM: [
        {
          tag: 'h1',
          attrs: {level: 1},
        },
        {
          tag: 'h2',
          attrs: {level: 2},
        },
        {
          tag: 'h3',
          attrs: {level: 3},
        },
        {
          tag: 'h4',
          attrs: {level: 4},
        },
        {
          tag: 'h5',
          attrs: {level: 5},
        },
        {
          tag: 'h6',
          attrs: {level: 6},
        },
      ],
    },
    blockquote: {
      group: 'flow',
      content: 'flow+',
      toDOM() {
        return ['blockquote', 0]
      },
      inline: false,
      parseDOM: [
        {
          tag: 'blockquote',
        },
      ],
    },
    thematicBreak: {
      // borrowing from mdast terminology
      group: 'flow',
      toDOM() {
        return ['hr']
      },
      inline: false,
      parseDOM: [
        {
          tag: 'hr',
        },
      ],
    },
    unsupported: {
      group: 'flow',
      content: 'text*',
      toDOM() {
        return ['div', {class: styles.unsupported}, 0]
      },
      inline: false,
      parseDOM: [
        {
          tag: `div.${styles.unsupported}`,
        },
      ],
      attrs: {},
    },
    text: {
      inline: true,
    },
  },
})
